export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  tags: string[];
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updatedAt: string;
  chapters: ComicChapter[];
}

export interface Category {
  name: string;
  slug: string;
  count: number;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '恋爱', slug: 'romance', count: 128, icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫，感受心动每一刻' },
  { name: '动作', slug: 'action', count: 95, icon: 'ri-sword-line', description: '热血沸腾的动作韩漫，酣畅淋漓的战斗场面' },
  { name: '奇幻', slug: 'fantasy', count: 87, icon: 'ri-magic-line', description: '充满想象力的奇幻世界，魔法与冒险的旅程' },
  { name: '悬疑', slug: 'thriller', count: 63, icon: 'ri-search-eye-line', description: '扣人心弦的悬疑韩漫，层层剥开真相' },
  { name: '搞笑', slug: 'comedy', count: 74, icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常韩漫，笑到停不下来' },
  { name: '都市', slug: 'urban', count: 56, icon: 'ri-building-line', description: '都市生活百态，职场与情感的纠葛' },
  { name: '校园', slug: 'school', count: 82, icon: 'ri-book-open-line', description: '青春校园故事，回味学生时代的美好' },
  { name: '古风', slug: 'historical', count: 45, icon: 'ri-ancient-gate-line', description: '唯美古风韩漫，穿越时空的浪漫邂逅' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '霸道总裁的契约新娘',
    author: '金恩淑',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20style%20illustration%20featuring%20a%20beautiful%20woman%20in%20elegant%20wedding%20dress%20with%20a%20handsome%20man%20in%20black%20suit%2C%20dramatic%20lighting%2C%20soft%20pastel%20background%2C%20romance%20genre%2C%20webtoon%20art%20style%2C%20clean%20composition%2C%20subtle%20sparkles&width=600&height=800&seq=comic-cover-1&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['总裁', '契约婚姻', '甜宠', '都市'],
    description: '为了挽救家族企业，她不得不与冷酷霸总签订契约婚姻。原以为只是一场交易，却发现冰山总裁的背后藏着不为人知的秘密。当真相一层层揭开，爱与恨的边界变得模糊……',
    status: '连载中',
    rating: 9.6,
    views: 2350000,
    favorites: 182000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch-1-120', title: '第120话 真相的彼岸', number: 120, updatedAt: '2026-08-04' },
      { id: 'ch-1-119', title: '第119话 无法回头', number: 119, updatedAt: '2026-07-28' },
      { id: 'ch-1-118', title: '第118话 暗流涌动', number: 118, updatedAt: '2026-07-21' },
      { id: 'ch-1-117', title: '第117话 选择的十字路口', number: 117, updatedAt: '2026-07-14' },
      { id: 'ch-1-116', title: '第116话 他的温柔', number: 116, updatedAt: '2026-07-07' },
      { id: 'ch-1-115', title: '第115话 雨夜的告白', number: 115, updatedAt: '2026-06-30' },
      { id: 'ch-1-114', title: '第114话 危机降临', number: 114, updatedAt: '2026-06-23' },
      { id: 'ch-1-113', title: '第113话 心动的瞬间', number: 113, updatedAt: '2026-06-16' },
    ],
  },
  {
    id: 'comic-2',
    title: '剑神无双',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20manhwa%20cover%20style%20illustration%20featuring%20a%20powerful%20swordsman%20with%20flowing%20dark%20hair%20holding%20a%20glowing%20energy%20sword%2C%20dynamic%20action%20pose%2C%20dramatic%20martial%20arts%20scene%2C%20dark%20stormy%20background%20with%20energy%20effects%2C%20webtoon%20style%2C%20intense%20lighting&width=600&height=800&seq=comic-cover-2&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['武侠', '升级', '热血', '战斗'],
    description: '平凡少年意外获得上古剑神传承，从此踏上逆天之路。一剑破万法，以凡人之躯比肩神明！在这个强者为尊的世界里，他要用手中之剑开辟属于自己的传说。',
    status: '连载中',
    rating: 9.4,
    views: 4120000,
    favorites: 298000,
    updatedAt: '2026-08-05',
    chapters: [
      { id: 'ch-2-210', title: '第210话 剑之极意', number: 210, updatedAt: '2026-08-05' },
      { id: 'ch-2-209', title: '第209话 巅峰对决', number: 209, updatedAt: '2026-07-29' },
      { id: 'ch-2-208', title: '第208话 领域展开', number: 208, updatedAt: '2026-07-22' },
      { id: 'ch-2-207', title: '第207话 突破极限', number: 207, updatedAt: '2026-07-15' },
      { id: 'ch-2-206', title: '第206话 剑意共鸣', number: 206, updatedAt: '2026-07-08' },
    ],
  },
  {
    id: 'comic-3',
    title: '魔法学院的天才少女',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20manhwa%20cover%20style%20illustration%20featuring%20a%20young%20female%20mage%20with%20long%20silver%20hair%20casting%20magic%20spells%2C%20wearing%20academy%20uniform%2C%20magical%20energy%20surrounding%20her%2C%20fantasy%20academy%20background%20with%20floating%20crystals%2C%20webtoon%20art%20style%2C%20ethereal%20atmosphere&width=600&height=800&seq=comic-cover-3&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['魔法', '学院', '天才', '逆袭'],
    description: '被家族抛弃的少女，在魔法学院入学测试中展露惊人天赋。从此一路高歌猛进，让所有看不起她的人刮目相看。魔法的世界，将由她重新定义。',
    status: '连载中',
    rating: 9.5,
    views: 1890000,
    favorites: 156000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-3-95', title: '第95话 终极试炼', number: 95, updatedAt: '2026-08-03' },
      { id: 'ch-3-94', title: '第94话 魔法对决', number: 94, updatedAt: '2026-07-27' },
      { id: 'ch-3-93', title: '第93话 禁术的秘密', number: 93, updatedAt: '2026-07-20' },
      { id: 'ch-3-92', title: '第92话 图书馆深处', number: 92, updatedAt: '2026-07-13' },
      { id: 'ch-3-91', title: '第91话 神秘导师', number: 91, updatedAt: '2026-07-06' },
    ],
  },
  {
    id: 'comic-4',
    title: '第七夜的秘密',
    author: '崔真实',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20thriller%20mystery%20manhwa%20cover%20style%20illustration%20featuring%20a%20shadowy%20figure%20standing%20in%20a%20foggy%20alley%20at%20night%2C%20mysterious%20atmosphere%2C%20detective%20theme%2C%20dim%20streetlight%2C%20dark%20and%20suspenseful%2C%20webtoon%20art%20style%2C%20noir%20aesthetic&width=600&height=800&seq=comic-cover-4&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['推理', '悬疑', '犯罪', '反转'],
    description: '连环失踪案的第七个夜晚，一名女记者深入调查，发现所有线索都指向十年前的一桩灭门惨案。当真相越来越近，危险也悄然而至……',
    status: '连载中',
    rating: 9.3,
    views: 1560000,
    favorites: 124000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-4-67', title: '第67话 最终嫌疑人', number: 67, updatedAt: '2026-08-02' },
      { id: 'ch-4-66', title: '第66话 隐藏的监控', number: 66, updatedAt: '2026-07-26' },
      { id: 'ch-4-65', title: '第65话 关键证物', number: 65, updatedAt: '2026-07-19' },
      { id: 'ch-4-64', title: '第64话 目击者', number: 64, updatedAt: '2026-07-12' },
    ],
  },
  {
    id: 'comic-5',
    title: '废柴逆袭记',
    author: '韩智敏',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20comedy%20manhwa%20cover%20style%20illustration%20featuring%20a%20funny%20chubby%20character%20with%20exaggerated%20expression%20in%20a%20silly%20situation%2C%20bright%20colorful%20background%2C%20humorous%20vibe%2C%20webtoon%20art%20style%2C%20playful%20and%20energetic%20composition&width=600&height=800&seq=comic-cover-5&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['逆袭', '搞笑', '系统', '日常'],
    description: '世界上最倒霉的废柴青年，某天突然绑定了"逆袭系统"。从此他的人生发生了翻天覆地的变化——但好像……变得更搞笑了？！爆笑日常，不容错过！',
    status: '已完结',
    rating: 9.2,
    views: 5670000,
    favorites: 421000,
    updatedAt: '2026-06-15',
    chapters: [
      { id: 'ch-5-185', title: '第185话 最终章：逆袭人生', number: 185, updatedAt: '2026-06-15' },
      { id: 'ch-5-184', title: '第184话 最后的考验', number: 184, updatedAt: '2026-06-08' },
      { id: 'ch-5-183', title: '第183话 系统升级', number: 183, updatedAt: '2026-06-01' },
      { id: 'ch-5-182', title: '第182话 全员集结', number: 182, updatedAt: '2026-05-25' },
    ],
  },
  {
    id: 'comic-6',
    title: '都市夜话',
    author: '尹智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20urban%20drama%20manhwa%20cover%20style%20illustration%20featuring%20a%20stylish%20woman%20in%20modern%20office%20attire%20looking%20out%20a%20high-rise%20window%20at%20night%20cityscape%2C%20sophisticated%20mood%2C%20warm%20interior%20lighting%2C%20webtoon%20art%20style%2C%20contemporary%20aesthetic&width=600&height=800&seq=comic-cover-6&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    tags: ['职场', '情感', '都市生活', '独立女性'],
    description: '在首尔这座不夜城里，五位都市女性的生活交织在一起。她们在职场上拼搏，在感情中摸索，在友谊中取暖。每个人都有自己的故事，每个夜晚都有不同的温度。',
    status: '连载中',
    rating: 9.1,
    views: 980000,
    favorites: 87000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch-6-54', title: '第54话 选择', number: 54, updatedAt: '2026-08-01' },
      { id: 'ch-6-53', title: '第53话 升职风波', number: 53, updatedAt: '2026-07-25' },
      { id: 'ch-6-52', title: '第52话 深夜加班', number: 52, updatedAt: '2026-07-18' },
      { id: 'ch-6-51', title: '第51话 闺蜜的婚礼', number: 51, updatedAt: '2026-07-11' },
    ],
  },
  {
    id: 'comic-7',
    title: '我们的青涩时光',
    author: '孙艺珍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20school%20romance%20manhwa%20cover%20style%20illustration%20featuring%20two%20high%20school%20students%20a%20boy%20and%20girl%20walking%20under%20cherry%20blossom%20trees%2C%20spring%20atmosphere%2C%20youthful%20and%20nostalgic%2C%20soft%20pink%20tones%2C%20webtoon%20art%20style%2C%20warm%20sunlight&width=600&height=800&seq=comic-cover-7&orientation=portrait',
    category: '校园',
    categorySlug: 'school',
    tags: ['青春', '校园', '纯爱', '成长'],
    description: '高中三年，他和她从陌生到熟悉，从同桌到知己再到……懵懂的感情在樱花纷飞的季节悄然萌芽。这是一段关于青春、关于成长、关于最纯粹初恋的故事。',
    status: '连载中',
    rating: 9.7,
    views: 3210000,
    favorites: 267000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch-7-78', title: '第78话 樱花之约', number: 78, updatedAt: '2026-08-04' },
      { id: 'ch-7-77', title: '第77话 学园祭', number: 77, updatedAt: '2026-07-28' },
      { id: 'ch-7-76', title: '第76话 雨天的伞', number: 76, updatedAt: '2026-07-21' },
      { id: 'ch-7-75', title: '第75话 运动会', number: 75, updatedAt: '2026-07-14' },
    ],
  },
  {
    id: 'comic-8',
    title: '凤舞九天',
    author: '姜素拉',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20historical%20fantasy%20manhwa%20cover%20style%20illustration%20featuring%20a%20beautiful%20woman%20in%20traditional%20Korean%20hanbok%20dress%20with%20intricate%20embroidery%2C%20ancient%20palace%20background%2C%20elegant%20and%20graceful%2C%20phoenix%20motif%2C%20webtoon%20art%20style%2C%20warm%20golden%20tones&width=600&height=800&seq=comic-cover-8&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    tags: ['古风', '宫斗', '重生', '权谋'],
    description: '前世被陷害致死的皇后，重生回到入宫第一天。这一次她不再隐忍，步步为营，翻手为云覆手为雨。且看她如何在这九重宫阙中，舞出一曲属于自己的凤舞九天。',
    status: '连载中',
    rating: 9.6,
    views: 2780000,
    favorites: 234000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-8-142', title: '第142话 册封大典', number: 142, updatedAt: '2026-08-03' },
      { id: 'ch-8-141', title: '第141话 太后之怒', number: 141, updatedAt: '2026-07-27' },
      { id: 'ch-8-140', title: '第140话 朝堂风暴', number: 140, updatedAt: '2026-07-20' },
      { id: 'ch-8-139', title: '第139话 暗棋出手', number: 139, updatedAt: '2026-07-13' },
    ],
  },
  {
    id: 'comic-9',
    title: '恋爱进行时',
    author: '金惠秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20cover%20style%20illustration%20featuring%20a%20couple%20sitting%20on%20a%20park%20bench%20at%20sunset%2C%20romantic%20atmosphere%2C%20warm%20orange%20and%20pink%20sky%2C%20webtoon%20art%20style%2C%20heartwarming%20and%20sweet%20composition&width=600&height=800&seq=comic-cover-9&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '甜蜜', '日常', '搞笑'],
    description: '两个社恐的恋爱故事！内向的插画师和害羞的程序员，在相亲中意外相遇。两个不善言辞的人，用最笨拙的方式谈着最甜的恋爱。全程姨母笑，甜到牙疼！',
    status: '连载中',
    rating: 9.5,
    views: 1980000,
    favorites: 165000,
    updatedAt: '2026-08-05',
    chapters: [
      { id: 'ch-9-63', title: '第63话 初次约会', number: 63, updatedAt: '2026-08-05' },
      { id: 'ch-9-62', title: '第62话 他的告白', number: 62, updatedAt: '2026-07-29' },
      { id: 'ch-9-61', title: '第61话 心意相通', number: 61, updatedAt: '2026-07-22' },
      { id: 'ch-9-60', title: '第60话 笨拙的温柔', number: 60, updatedAt: '2026-07-15' },
    ],
  },
  {
    id: 'comic-10',
    title: '最强猎魔师',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20fantasy%20manhwa%20cover%20style%20illustration%20featuring%20a%20demon%20hunter%20with%20tattoos%20and%20a%20massive%20weapon%2C%20dark%20gothic%20city%20background%2C%20monsters%20lurking%20in%20shadows%2C%20intense%20and%20dynamic%2C%20webtoon%20art%20style%2C%20supernatural%20theme&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['猎魔', '超能力', '战斗', '黑暗'],
    description: '在现代都市的阴影中，恶魔潜伏在人群之间。猎魔师是人类的最后防线。他拥有最强的猎魔血脉，却隐藏身份过着一家小面馆老板的生活。直到那一天，恶魔找上了门……',
    status: '连载中',
    rating: 9.3,
    views: 3450000,
    favorites: 256000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch-10-167', title: '第167话 地狱之门', number: 167, updatedAt: '2026-08-04' },
      { id: 'ch-10-166', title: '第166话 魔王降临', number: 166, updatedAt: '2026-07-28' },
      { id: 'ch-10-165', title: '第165话 最终防线', number: 165, updatedAt: '2026-07-21' },
      { id: 'ch-10-164', title: '第164话 觉醒之力', number: 164, updatedAt: '2026-07-14' },
    ],
  },
  {
    id: 'comic-11',
    title: '异世界食堂',
    author: '全智贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20slice%20of%20life%20manhwa%20cover%20style%20illustration%20featuring%20a%20cozy%20restaurant%20in%20a%20magical%20world%2C%20various%20fantasy%20creatures%20dining%2C%20warm%20lighting%2C%20delicious%20food%2C%20whimsical%20and%20heartwarming%2C%20webtoon%20art%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['美食', '异世界', '温馨', '治愈'],
    description: '一扇神秘的门连接着现代厨房和异世界餐厅。精灵、兽人、龙族……各种奇幻生物被美食吸引而来。没有什么是一顿美食解决不了的，如果有，那就两顿。',
    status: '连载中',
    rating: 9.4,
    views: 1230000,
    favorites: 98000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-11-89', title: '第89话 龙族的甜点', number: 89, updatedAt: '2026-08-02' },
      { id: 'ch-11-88', title: '第88话 精灵的下午茶', number: 88, updatedAt: '2026-07-26' },
      { id: 'ch-11-87', title: '第87话 矮人的烤肉', number: 87, updatedAt: '2026-07-19' },
    ],
  },
  {
    id: 'comic-12',
    title: '完美谎言',
    author: '张瑞希',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20psychological%20thriller%20manhwa%20cover%20style%20illustration%20featuring%20a%20woman%20with%20half%20her%20face%20in%20shadow%2C%20fragmented%20mirror%20effect%2C%20tense%20and%20unsettling%20atmosphere%2C%20dark%20and%20moody%2C%20webtoon%20art%20style%2C%20psychological%20theme&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['心理', '反转', '真相', '人性'],
    description: '一个完美的妻子、一个完美的母亲、一个完美的谎言。当警方在她家的地下室发现一具尸体后，所有的"完美"都开始崩塌。每个人都在说谎，但真相只有一个。',
    status: '已完结',
    rating: 9.5,
    views: 2130000,
    favorites: 178000,
    updatedAt: '2026-05-20',
    chapters: [
      { id: 'ch-12-72', title: '第72话 终章：真相大白', number: 72, updatedAt: '2026-05-20' },
      { id: 'ch-12-71', title: '第71话 最后的证词', number: 71, updatedAt: '2026-05-13' },
      { id: 'ch-12-70', title: '第70话 法庭对决', number: 70, updatedAt: '2026-05-06' },
    ],
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getPopularComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getTopRatedComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};

export const getRelatedComics = (comic: Comic, limit: number = 4): Comic[] => {
  return comics.filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug).slice(0, limit);
};